<!-- Footer Start -->
<footer class="footer">
    <p class="m-0 text-center p-2">
        © {{this.currentYear}} Gigatel Solutions Pvt. Ltd. | 
        <!-- <span class="text-gradient"><a href="https://gigatel.solutions/" target="_blank"
                class="link link-underline fw-semibold">contact Us</a></span> -->
                 <a routerLink="/customer-portal/common-pages/t-and-c" class="footer-link">Terms & Conditions</a> |
        <a routerLink="/customer-portal/common-pages/p-and-p" class="footer-link">Privacy Policy</a> |
        <a routerLink="/customer-portal/common-pages/nfp" class="footer-link">Refund Policy</a> |
        <a routerLink="/customer-portal/common-pages/cp" class="footer-link">Cancellation Policy</a>
    </p>

</footer>
<!-- Footer End -->